import React from "react";
import TablaCampana from "js/pages/Unilever/Campana/Tabla";

function Campana(props) {
  return <TablaCampana />;
}

export default Campana;
